<template>
  <div class="AdvertisementDetail">
    <HeaderAdvertisementDetail />
    <AdvertisementGeneralDetails />
    <SummaryLineChart />
  </div>
</template>

<script>
import { Card } from '@/components';

import HeaderAdvertisementDetail from './HeaderAdvertisementDetail.vue';
import AdvertisementGeneralDetails from './AdvertisementGeneralDetails.vue';
import SummaryLineChart from './SummaryLineChart.vue';

export default {
  name: 'AdvertisementDetail',
  components: {
    Card,
    HeaderAdvertisementDetail,
    AdvertisementGeneralDetails,
    SummaryLineChart,
  },
};
</script>
<style lang="scss">
.AdvertisementDetail {
  width: 100%;
  height: 100%;
  &__Details {
    .Name_Sector {
      .Card {
        width: rem(250);
        height: rem(100);
        margin: rem(10);
      }
      display: flex;
      justify-content: center;
    }
    .List {
      width: 60%;
      .Detail {
        display: flex;
        justify-content: center;
        align-items: center;
        border: rem(1px) solid $white-700;
        margin-top: rem(10);
        p {
          padding: rem(25);
        }
      }
    }
  }
}
</style>
